"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchoolByDomain = exports.getSchools = void 0;
var getSchoolByDomain_1 = __importDefault(require("./getSchoolByDomain"));
exports.getSchoolByDomain = getSchoolByDomain_1.default;
var getSchools_1 = __importDefault(require("./getSchools"));
exports.getSchools = getSchools_1.default;
